import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import WhatsAppTemplateList from './WhatsAppTemplateList';
import SMSTemplateList from './SMSTemplateList'
import EmailTemplateList from './EmailTemplateList'


const TemplateRegisterScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    // const {

    // } = InvoiceSettingsController()

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:10}}>
                <h2 className='title'>Template Register</h2>
            </div>

            <div >
            <Tabs tabs={['WhatsApp','Email','SMS',]}
            selectedIndex={selectedTab}
            onTabChange={handleTabChange}>
                    <WhatsAppTemplateList />
                    <EmailTemplateList />
                    <SMSTemplateList />
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default TemplateRegisterScreen;